import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'menu',
    loadChildren: () =>
      import('./pages/menu/menu.module').then((m) => m.MenuPageModule),
  },
  {
    path: 'product/:id',
    loadChildren: () =>
      import('./pages/product-detail/product-detail.module').then(
        (m) => m.ProductDetailPageModule
      ),
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./pages/checkout/checkout.module').then(
        (m) => m.CheckoutPageModule
      ),
  },
  {
    path: 'thanks',
    loadChildren: () =>
      import('./pages/thanks/thanks.module').then((m) => m.ThanksPageModule),
  },
  {
    path: 'user-detials',
    loadChildren: () =>
      import('./pages/user-detials/user-detials.module').then(
        (m) => m.UserDetialsPageModule
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./pages/settings/settings.module').then(
        (m) => m.SettingsPageModule
      ),
  },
  {
    path: 'kiosk-code',
    loadChildren: () =>
      import('./pages/kiosk-code/kiosk-code.module').then(
        (m) => m.KioskCodePageModule
      ),
  },
  {
    path: '',
    redirectTo: 'kiosk-code',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'kiosk-code',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
